import NPSModal from './NPSModal';
export default NPSModal;